import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={30}
      height={21}
      viewBox="0 0 30 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4741_4679)">
        <rect
          width={29.4324}
          height={19.6216}
          transform="translate(0 0.810791)"
          fill="white"
        />
        <g clipPath="url(#clip1_4741_4679)">
          <rect
            width={29.4324}
            height={19.6216}
            transform="translate(0 0.810791)"
            fill="white"
          />
          <rect
            x={0.621582}
            y={1.28375}
            width={28.43}
            height={18.62}
            fill="url(#paint0_linear_4741_4679)"
            stroke="white"
          />
          <path
            d="M11.6088 5.89045L12.1216 6.00542C12.5104 6.11105 12.8905 6.26217 13.2619 6.45874L13.7961 6.80367C14.0219 6.97413 14.2291 7.16441 14.4176 7.37453C14.726 7.72498 14.9751 8.11243 15.165 8.53686C15.378 9.03414 15.5128 9.55341 15.5697 10.0947L15.5877 10.2769L15.5878 10.2801C15.5878 10.2974 15.5736 10.3118 15.5562 10.3118L15.2777 10.3132L14.5678 10.3127H11.738L10.3123 10.3132C10.3054 10.3132 10.2997 10.3189 10.2997 10.3258L10.2992 11.2207C10.2992 11.2319 10.3083 11.241 10.3195 11.241L11.2447 11.2402L12.5454 11.2379L14.347 11.2388L14.9342 11.2382L15.5605 11.2353C15.5746 11.2353 15.5866 11.2469 15.5866 11.2611L15.5865 11.2628C15.5566 11.6924 15.4787 12.1099 15.3529 12.5155C15.0896 13.3649 14.6192 14.0711 13.9417 14.6339C13.7521 14.7732 13.5602 14.9202 13.3631 15.0318C13.1774 15.1366 12.985 15.2319 12.786 15.3175C12.4958 15.4307 12.1957 15.5248 11.8859 15.5998C11.5747 15.6631 11.2613 15.7092 10.9455 15.7382C10.5651 15.7657 10.1898 15.7659 9.81952 15.7391C9.46868 15.7122 9.13091 15.6632 8.8062 15.5921L8.13581 15.393L7.69192 15.2048C7.4326 15.079 7.19456 14.9369 6.97777 14.7787C6.89425 14.7174 6.79264 14.6372 6.67289 14.5378C6.44657 14.3327 6.23979 14.1111 6.05254 13.8732C5.60485 13.2504 5.32171 12.5568 5.2031 11.7922C5.18042 11.6454 5.16086 11.5054 5.14447 11.3723C5.13741 11.2404 5.13151 11.1159 5.12674 10.9988C5.05524 9.21469 5.72478 7.5101 7.30296 6.55484C7.64751 6.34814 8.01348 6.18532 8.40093 6.06634C8.94872 5.89874 9.51055 5.80751 10.0864 5.79264C10.1868 5.79321 10.2911 5.78177 10.385 5.78406C10.8363 5.79635 11.1786 5.81695 11.6088 5.89045Z"
            fill="white"
          />
          <path
            d="M16.8648 6.0621L17.4654 6.06467L18.9172 6.0641L19.2418 6.0621L20.1395 6.06324L21.2029 6.06267L21.7772 6.0641L22.5546 6.06438C22.9064 6.05866 23.2046 6.0784 23.4492 6.12359C23.4921 6.13139 23.5806 6.15239 23.7146 6.18651C23.9621 6.26888 24.1837 6.39586 24.3793 6.56747C24.8045 6.9448 25.0425 7.42091 25.0935 7.99578C25.102 8.09168 25.1017 8.23165 25.0926 8.41564C25.0832 8.47513 25.0729 8.53527 25.0614 8.59611C24.947 9.2051 24.6338 9.67301 24.1219 9.99982C23.9469 10.1117 23.7464 10.1909 23.5204 10.2372C23.23 10.2868 22.9799 10.3117 22.7699 10.3119C22.1951 10.3126 21.6204 10.3129 21.0459 10.3127L19.6305 10.3133H18.7933L17.1133 10.3147L16.4532 10.3121C16.4395 10.3121 16.4326 10.3053 16.4326 10.2916L16.4318 6.98875L16.4338 6.17507L16.4318 6.07868C16.4318 6.07857 16.4318 6.07848 16.4318 6.07837C16.4316 6.06927 16.4391 6.06167 16.4484 6.06152C16.4485 6.06152 16.4486 6.06152 16.4486 6.06152L16.8648 6.0621Z"
            fill="white"
          />
          <path
            d="M16.8787 11.2356L18.4881 11.2394L19.3243 11.2411L20.9611 11.2396C21.6449 11.2412 22.3288 11.2426 23.013 11.2439C23.0848 11.2439 23.1987 11.2559 23.3544 11.2797C24.0477 11.3632 24.6172 11.8094 24.9069 12.438C25.0651 12.7946 25.1274 13.1609 25.0936 13.5371C25.0261 14.2941 24.6617 14.8615 24.0002 15.2394C23.5647 15.4474 23.1088 15.4748 22.6274 15.4751C22.3647 15.4753 22.1018 15.4752 21.8389 15.4748L20.7947 15.4751L20.0036 15.4754L18.2738 15.4785L18.0599 15.4757L16.7586 15.4754L16.4646 15.4788C16.4457 15.4771 16.4362 15.471 16.4362 15.4605C16.4364 14.5478 16.4359 13.6343 16.4345 12.72L16.434 11.2737C16.434 11.2479 16.4467 11.2352 16.4723 11.2354L16.8787 11.2356Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4741_4679"
          x1={0.121582}
          y1={1.36104}
          x2={29.5516}
          y2={19.8265}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.175} stopColor="#061C65" />
          <stop offset={0.343935} stopColor="#195599" />
          <stop offset={0.5} stopColor="#B7BBC1" />
          <stop offset={0.585288} stopColor="#BA8D93" />
          <stop offset={0.676134} stopColor="#B45054" />
          <stop offset={0.85} stopColor="#AF0707" />
        </linearGradient>
        <clipPath id="clip0_4741_4679">
          <rect
            width={29.4324}
            height={19.6216}
            fill="white"
            transform="translate(0 0.810791)"
          />
        </clipPath>
        <clipPath id="clip1_4741_4679">
          <rect
            width={29.4324}
            height={19.6216}
            fill="white"
            transform="translate(0 0.810791)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-cartes-bancaires" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
